<template>
	<b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" :title="title" size="1600" class="modal-primary" @hidden="clearModalData">
		<CRow v-if="mode === mode_DETAILS1">
			<CCol>
				<b-card>
					<div id="warranyClaimPaymentsCustomActions">
					</div>
					<b-table
						ref="warrantyClaimPaymentsTable"
						striped
						responsive
						hover
						show-empty
						:empty-text="isLoading ? 'Nalaganje' : 'Ni vnosov'"
						:fields="warrantyClaimPaymentsTableProps.fields"
						:items="warrantyClaimPaymentsTableProps_items"
						:current-page="warrantyClaimPaymentsTableProps.currentPage"
						:per-page="warrantyClaimPaymentsTableProps.itemsPerPage">
						<template v-slot:cell(claim_date)="data">
							<span v-if="data.item.claim_date">{{ data.item.claim_date | viewDate }}</span>
						</template>
						<template v-slot:cell(labour)="data">
							{{ data.item.labour | hr_money }}
						</template>
						<template v-slot:cell(part)="data">
							{{ data.item.part | hr_money }}
						</template>
						<template v-slot:cell(grand_total)="data">
							{{ data.item.grand_total | hr_money }}
						</template>
					</b-table>
					<nav v-if="showWarrantyClaimPaymentsTableNav">
						<b-row>
							<b-col>
								<b-pagination :total-rows="warrantyClaimPaymentsTableProps.totalItems" :per-page="warrantyClaimPaymentsTableProps.itemsPerPage" v-model="warrantyClaimPaymentsTableProps.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
							</b-col>
							<b-col cols=2>
								<a class="page-link rows_total float-right">Št. vrstic: {{ warrantyClaimPaymentsTableProps.totalItems }}</a>
							</b-col>
							<b-col cols=1>
								<b-form-select v-model="warrantyClaimPaymentsTableProps.itemsPerPage" :options="warrantyClaimPaymentsTableProps.options_numRowsOnPage"></b-form-select>
							</b-col>
						</b-row>
					</nav>
					<vue-loading :active.sync="warrantyClaimPaymentsTableProps.isLoading" :is-full-page="false"/>
				</b-card>
			</CCol>
		</CRow>
		<CAlert v-show="message.text != null" :color="message.type">
			{{ message.text }}
		</CAlert>
		<template slot="modal-footer" slot-scope="{ cancel }">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="cancel()">Zapri</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
		<vue-loading :active.sync="isLoading" :is-full-page="false"/>
	</b-modal>
</template>

<script>
import { WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED } from "@/store/actions/warrantyClaimPayments";
import _ from 'lodash';

export default {
	name: 'warranty-claim-modal',
	components: {
	},
	props: {
	},
	methods: {
		showModal: function (modalInput) {
			/*
				mode 1 => Details (Warranty claim payments list)
			*/
			this.mode = modalInput.mode;
			this.initModal(modalInput.warrantyClaim);
		},
		initModal: function (warrantyClaim) {
			if (this.mode === this.mode_DETAILS1) {
				this.title = 'Plačila garancijskega zahtevka';
				this.okButton.label = 'Zapri';
				this.initwarrantyClaim(warrantyClaim);
				this.warrantyClaimPaymentsTableProps.inputFilter.warrantyClaimId = this.warrantyClaim.id;
			} else {
				this.mode = this.mode_UNKNOWN0;
				this.title = 'Neznan način';
				this.okButton.label = 'Zapri';
			}
			this.$refs.modal.show();
		},
		initwarrantyClaim: function (object) {
			this.warrantyClaim.id = object.id;
		},
		clearModalData: function () {
			this.isLoading = false;
			this.title = '';
			this.okButton = {
				label: 'Shrani',
				progress: false,
				disabled: false
			};
			this.showAlert();
			this.mode = 0;
			this.resetwarrantyClaimObject();
			this.resetwarrantyClaimPaymentsTable();
		},
		resetwarrantyClaimObject: function () {
			this.warrantyClaim.id = null;
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		warrantyClaimPaymentsTableProps_items: function (ctx) {
			this.startProgress();
			return this.$store.dispatch(WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED, { ctx: ctx, tableProps: this.warrantyClaimPaymentsTableProps })
				.then((responseData) => {
					this.stopProgress();
					this.warrantyClaimPaymentsTableProps.items = responseData.warrantyClaimPaymentsPagination.data;
					this.warrantyClaimPaymentsTableProps.totalItems = responseData.warrantyClaimPaymentsPagination.total;
					this.warrantyClaimPaymentsTableProps.empty_text = 'Ni vnosov';
					return this.warrantyClaimPaymentsTableProps.items;
				})
				.catch(error => {
					this.stopProgress();
					this.warrantyClaimPaymentsTableProps.items = [];
					this.warrantyClaimPaymentsTableProps.totalItems = 0;
					this.warrantyClaimPaymentsTableProps.empty_text = 'Napaka pri pridobivanju posegov naročila';
					console.log(error);
					return [];
				});
		},
		resetwarrantyClaimPaymentsTable: function () {
			this.warrantyClaimPaymentsTableProps.sortDesc = true;
			this.warrantyClaimPaymentsTableProps.currentPage = 1;
			this.warrantyClaimPaymentsTableProps.itemsPerPage = 10;
			this.warrantyClaimPaymentsTableProps.totalItems = 0;
			this.warrantyClaimPaymentsTableProps.inputFilter.warrantyClaimId = null;
			this.warrantyClaimPaymentsTableProps.textFilterTimeout = null;
			this.warrantyClaimPaymentsTableProps.errorText = '';
		},
	
	},
	data: function () {
		return {
			isLoading: false,
			title: '',
			okButton: {
				label: 'Shrani',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			ALERT_TYPE_WARNING: 'warning',
			mode_UNKNOWN0: 0,
			mode_DETAILS1: 1,
			mode: 0,
			warrantyClaim: {
				id: null,
			},
			warrantyClaimPaymentsTableProps: {
				fields: [
					{ key: 'id', label: 'Id', sortable: true, class: 'tdwarrantyClaimPaymentsId' },
					{ key: 'cdp_invoice_number', label: 'CDP Invoice', sortable: true, class: 'tdwarrantyClaimPaymentsId' },
					{ key: 'invoice_number', label: 'Invoice number', sortable: true, class: 'tdwarrantyClaimPaymentsId' },
					{ key: 'claim_date', label: 'Claim date', sortable: true, class: 'tdwarrantyClaimPaymentsId' },
					{ key: 'vin', label: 'vin', sortable: true, class: 'tdwarrantyClaimPaymentsId' },
					{ key: 'expense_code', label: 'expenseCode', sortable: true, class: 'tdwarrantyClaimPaymentsId' },
					{ key: 'labour', label: 'LABOUR', sortable: true, class: 'tdwarrantyClaimPaymentsId' },
					{ key: 'part', label: 'PART', sortable: true, class: 'tdwarrantyClaimPaymentsId' },
					{ key: 'grand_total', label: 'Grand Total', sortable: true, class: 'tdwarrantyClaimPaymentsId' },
				],
				sortDesc: true,
				currentPage: 1,
				itemsPerPage: 10,
				totalItems: 0,
				isLoading: false,
				options_numRowsOnPage: [
					{ value: 10, text: '10' },
					{ value: 100, text: '100' },
					{ value: 200, text: '200' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				inputFilter: {
					warrantyClaimId: null
				},
				textFilterTimeout: null,
				errorText: ''
			},
		}
	},
	watch: {
	},
	computed: {
		profile() {
			return this.$store.getters.getProfile
		},
		modalSize () {
			return 'xl';
		},
		showWarrantyClaimPaymentsTableNav () {
			if (this.warrantyClaimPaymentsTableProps.totalItems > this.warrantyClaimPaymentsTableProps.itemsPerPage) {
				return true;
			}
			return false;
		},
	},
	created () {
	}
}
</script>

<style scoped>
#warranyClaimPaymentsCustomActions {
  position: absolute;
  top: 1.4rem;
  right: 1.4rem;
  z-index: 1;
}
.ma_pos {
	text-align: end;
}
</style>
<style>
div.modal .modal-dialog.modal-1600 {
  max-width: 1600px !important;
}
</style>